var collapsible_list_pair_rtlignore_default = {
  "container": "eK1Iz",
  "title": "uqlo-",
  "viewerContainer": "b8zYK",
  "titleContainer": "J-1kD",
  "content": "-EXdA",
  "expandIcon": "cN6Uz",
  "dndIcon": "bIonP",
  "RTL": "rb9tP",
  "LTR": "jXLlL",
  "itemContainer": "jEcBF",
  "itemContainerViewer": "_0iWD2",
  "mouseDown": "Xa2NF",
  "innerEditor": "gl-47",
  "item": "Mq1NS",
  "floatingAddPluginMenuWrapper": "K3aRg"
};
export {
  collapsible_list_pair_rtlignore_default as default
};
//# sourceMappingURL=collapsible-list-pair.rtlignore-scss.js.map
